import { useEffect, useState } from 'react';
import { getPostsByCategory, getPostsByTag } from '../../content/engine/postIndex';
import ArticleCard from './ArticleCard';

// The Landing Pages → Blog Articles link in the content engine's internal
// linking chain. Renders nothing at all — not even the heading — until a
// published post actually matches, so it's a genuine no-op today (zero
// articles exist yet) and activates automatically once content ships.
export default function FromTheBlog({ category, tag, limit = 3 }) {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    let cancelled = false;
    const load = category ? getPostsByCategory(category) : tag ? getPostsByTag(tag) : Promise.resolve([]);
    load.then(result => { if (!cancelled) setPosts(result.slice(0, limit)); });
    return () => { cancelled = true; };
  }, [category, tag, limit]);

  if (posts.length === 0) return null;

  return (
    <section className="block shell lp-from-blog">
      <div className="kicker"><span className="kicker-line" /> From the Blog</div>
      <h2 className="h">More on <span className="stamp">this topic.</span></h2>
      <div className="lp-from-blog-grid">
        {posts.map(p => <ArticleCard key={p.slug} post={p} />)}
      </div>
    </section>
  );
}
